<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <filter-manager
          v-model="searchModel.filters"
          ref="reportFilterRef"
          :filters="filterManagerConfig"
          @search="this.downloadReport"
          items-container-class="flex-wrap"
          :display-advanced="false"
          class="search-bar"
          search-text="Procesar"
          search-icon="fa fa-sync"
          search-container-class="btn-process"
          :is-advanced="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import RrhhServices from '@/services/api/rrhh.api'
import locationServices from '@/services/api/location.api'
import DocumentsService from '@//modules/report/document'
import rrhhReportType from '@/utils/constants/rrhhReportType.js'

const ReportTypes = [
  { id: 1, name: 'Escuela'},
  { id: 2, name: 'Maestro'},
  { id: 3, name: 'Estudiante'}
];


export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    searchModel: {
      collections: {
        academicYears: [],
        regions: [],       
        municipalities: [],        
        schools: [],
        teachers: [],
        assistants: [],
        reportType:[]
      },
      filters: {
        academicYear: null,
        region: null,
        municipality: null,
        school: null,       
        teacher: null,
        assistant: null,
        reportType: null,
        sie: null,
      },
    },
    page: {
      icon: 'fas fa-chart-pie',
      title: 'Informe de Recursos Humanos',
      routes: ['Informes', 'Informe de Recursos Humanos'],
    },
    results: [],
  }),
  computed: {    
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          options: this.searchModel.collections.academicYears,
          initialValue: null,
          component: 'custom-drop-down',
          label: 'Año Académico',
          placeholder: 'Seleccione',
          clearable: false,
          fieldKey: 'id',
          fieldName: 'name',
          onChanged: this.onChangedAcademicYear,
          class: 'col-md-3',
          validations: this.searchModel.filters.academicYear === null || this.searchModel.filters.academicYear === undefined ? 'required' : '',
          error: 'Es requerido seleccionar el año académico.'
        },
        {
          name: 'region',
          component: 'custom-drop-down',
          options: this.searchModel.collections.regions,
          label: 'Región',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          onChanged: this.onChangedRegion,
          initialValue: null,
          class: 'col-md-3',
          validations: this.searchModel.filters.region === null || this.searchModel.filters.region === undefined ? 'required' : '',
          error: 'Es requerido seleccionar la región.',
        },
        {
          name: 'municipality',
          component: 'custom-drop-down',
          options: this.searchModel.collections.municipalities,
          label: 'Municipio',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          onChanged: this.onChangedMunicipality,
          initialValue: null,
          class: 'col-md-3',
          disabled: this.searchModel.filters?.region === null,
          validations: this.searchModel.filters.municipality === null || this.searchModel.filters.municipality === undefined ? 'required' : '',
          error: 'Es requerido seleccionar el municipio.'
        },
        {
          name: 'school',
          component: 'custom-drop-down',
          options: this.searchModel.collections.schools,
          initialValue: null,
          label: 'Escuela',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          onChanged: this.onChangedSchool,
          class: 'col-md-3',
          disabled: this.searchModel.filters?.municipality === null,
          validations: this.searchModel.filters.school === null || this.searchModel.filters.school === undefined ? 'required' : '',
          error: 'Es requerido seleccionar la escuela.'
        },
        {
          name: 'reportType',
          component: 'custom-drop-down',
          options: this.searchModel.collections.reportTypes,
          initialValue: null,
          label: 'Tipo de Reporte',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-md-3 mt-3',
          disabled: this.searchModel.filters?.school === null,
          validations: this.searchModel.filters.reportType === null || this.searchModel.filters.reportType === undefined ? 'required' : '',
          error: 'Es requerido seleccionar el tipo de reporte.',
          onChanged: this.onReportTypeChanged
        },
        {
          name: 'teacher',
          visible: this.searchModel.filters.reportType?.id == rrhhReportType.Teacher,
          component: 'custom-drop-down',
          options: this.searchModel.collections.teachers,          
          label: 'Maestro',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-md-3 mt-3',                    
        },
        {
          name: 'assistant',
          visible: this.searchModel.filters.reportType?.id == rrhhReportType.School,
          component: 'custom-drop-down',
          label: 'Asistente',
          placeholder: 'Seleccione',
          options: this.searchModel.collections.assistants,          
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-md-3 mt-3',                    
        },
        {
          name: 'sie',
          visible: this.searchModel.filters.reportType?.id == rrhhReportType.Student,
          component: 'CustomInput',
          placeholder: 'Escriba Número de SIE',
          label: 'SIE',
          icon: 'fa fa-search orange-icon',
          value: this.searchModel.filters.sie,
          leftIcon: true,
          type: 'text',
          class: 'col-md-3 mt-3',        
        },        
      ]
    },
  },
  async mounted() {
    await this.initFilters();
  },
  methods: {
    async initFilters() {
      const { data } = await RrhhServices.getRrhhInitFilters();
      this.searchModel.collections.academicYears = data.academicYears;      
      this.searchModel.collections.regions = data.regions;      
      this.searchModel.filters.academicYear = data.currentAcademicYear;
      this.searchModel.collections.reportTypes = ReportTypes;  
    },    
    onChangedAcademicYear(){      
      this.searchModel.filters.region = null;
      this.searchModel.filters.municipality = null;
      this.searchModel.filters.school = null;
      this.searchModel.filters.reportType = null;      
    },
    async onChangedRegion() {
      const regionId = this.searchModel.filters.region?.id;
      const academicYearId = this.searchModel.filters.academicYear?.id;

      this.searchModel.filters.municipality = null;
      this.searchModel.collections.municipalities = [];
      this.searchModel.filters.school = null;
      this.searchModel.collections.schools = [];
      this.onChangedMunicipality();

      if(regionId)
      {
        //cargamos municipalidad
        locationServices
          .getMunicipalities({
            AcademicYearId: academicYearId,
            RegionId: regionId,
          })
          .then((res) => {
            this.searchModel.collections.municipalities = res.data;
            this.searchModel.filters.municipality = this.searchModel.collections.municipalities.filter(
              (s) => s.selected
            )[0];
          })      
      }      
    },
    async onChangedMunicipality() {
      const academicYearId = this.searchModel.filters.academicYear?.id;
      const municipalityId = this.searchModel.filters.municipality?.id;

      this.searchModel.filters.school = null;
      this.searchModel.collections.schools = [];
      this.onChangedSchool();

      if(municipalityId)
      {
        //obtener escuela
        locationServices
          .getSchools({
            AcademicYearId: academicYearId,
            MunicipalityId: municipalityId,
          })
          .then((res) => {
            this.searchModel.collections.schools = res.data;
            this.searchModel.filters.school = this.searchModel.collections.schools.filter(
              (s) => s.selected
            )[0];
          })
      }      
    },
    onChangedSchool(){
      this.searchModel.filters.reportType = null;      
      this.searchModel.filters.teacher = null;
      this.searchModel.filters.assistant = null;
      this.searchModel.filters.sie = null;
    },
    async onReportTypeChanged()
    { 
      this.searchModel.collections.teachers = [];
      this.searchModel.collections.assistants = [];
      this.searchModel.filters.teacher = null;
      this.searchModel.filters.assistant = null;
      this.searchModel.filters.sie = null;
      
      if(this.searchModel.filters.reportType?.id == rrhhReportType.Teacher)
      {      
        const { data } = await RrhhServices.getTeachers(this.searchModel.filters.academicYear?.id, this.searchModel.filters.school?.id);
        this.searchModel.collections.teachers = data;
      }
      else if(this.searchModel.filters.reportType?.id == rrhhReportType.School)
      {
        const { data } = await RrhhServices.getAssistants(this.searchModel.filters.academicYear?.id, this.searchModel.filters.school?.id);                
        this.searchModel.collections.assistants = data;        
      }
    },
    async downloadReport() {
      const isValid = await this.$refs.reportFilterRef.$refs.formValidator.validate();

      if (isValid) {
        RrhhServices.getReport({
            AcademicYearId: this.searchModel.filters.academicYear?.id,
            SchoolId: this.searchModel.filters.school?.id,
            StudentSieId: this.searchModel.filters.sie,
            AssistantId: this.searchModel.filters.assistant?.id,
            TeacherId: this.searchModel.filters.teacher?.id,
            ReportType: this.searchModel.filters.reportType?.id            
          })
          .then((res) => {
            DocumentsService.Download(res.data);
          })
      }
    },
  },
}
</script>